import { newId } from "../utils/dataTypesUtils"
import { CustomerType } from "../../../modules/sales"

export const FinalCustomerName = 'Cliente Final'

export const customerTypes = (companyId: string): CustomerType[] => [
    { companyId, id: newId(), name: FinalCustomerName, yield: 0, productYields: [] },
    { companyId, id: newId(), name: 'Arquitecto', yield: 0, productYields: [] },
    { companyId, id: newId(), name: 'Constructora', yield: 0, productYields: [] },
    { companyId, id: newId(), name: 'Corralón', yield: 0, productYields: [] }
]
